import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cancelButtonText: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.button.cancel',
    description: 'Cancel button text',
    defaultMessage: 'Cancel',
  },
  confirmButtonText: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.button.confirm',
    description: 'Confirm button text',
    defaultMessage: 'Confirm',
  },
  activateButtonText: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.button.activate',
    description: 'Activate button text',
    defaultMessage: 'Activate',
  },
  deactivateButtonText: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.button.deactivate',
    description: 'Deactivate button text',
    defaultMessage: 'Deactivate',
  },
  atlassianIntelligencePageTitle: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.header',
    description: 'Title for Atlassian Intelligence section',
    defaultMessage: 'Atlassian Intelligence',
  },
  atlassianIntelligencePageDescription: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.description',
    description:
      'Description for Atlassian Intelligence section. The "Learn about Atlassian Intelligence" link text is wrapped in <link> tags.',
    defaultMessage:
      'Atlassian Intelligence (AI) is an artificial intelligence tool to help your users work more effectively. <link>Learn about Atlassian Intelligence</link>',
  },
  atlassianIntelligenceRovoChatPreferenceHeader: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.rovoChat.preferences.header',
    description: 'Header for Rovo Chat Preferences',
    defaultMessage: 'Rovo Chat',
  },
  atlassianIntelligenceRovoChatPreferenceSubHeader: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.rovoChat.preferences.subheader',
    description: 'Sub-header for Rovo Chat Preferences',
    defaultMessage:
      "User access to Rovo Chat is determined by the connected Jira site's AI settings. Visit ",
  },
  atlassianIntelligenceRovoChatPreferenceSubHeaderAtlassianAdmin: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.rovoChat.preferences.subheader.atlassian.admin',
    description: 'Hyperlink message for rovo chat atlassian admin',
    defaultMessage: 'Atlassian Administration.',
  },
  atlassianIntelligenceRovoChatPreferenceDescription: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.rovoChat.preferences.description',
    description: 'Description for Rovo Chat Preferences',
    defaultMessage:
      'Rovo Chat boosts learning with tailored insights and answers, delivering the exact knowledge you need in the context of your work.',
  },
  atlassianIntelligenceRovoChatPreferenceDescriptionLearnMore: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.rovoChat.preferences.description.learnMore',
    description: 'Hyperlink message for rovo chat preference description',
    defaultMessage: 'Learn more about Rovo Chat.',
  },
  atlassianIntelligenceRovoChatPreferenceTooltip: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.rovoChat.preferences.tooltip',
    description: 'Tooltip message for rovo chat preference description',
    defaultMessage:
      'To use this feature, connect to a Jira site with AI enabled.',
  },
  atlassianIntelligenceRovoChatPreferenceLozenge: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.rovoChat.preferences.lozenge',
    description: 'Lozenge message for Rovo Chat Enablement',
    defaultMessage: 'BETA',
  },
  atlassianIntelligenceAiWritingAssistantPreferenceHeader: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.aiWritingAssistant.preferences.header',
    description: 'Header for AI writing assistant preference',
    defaultMessage: 'AI writing assistant',
  },
  atlassianIntelligenceAiWritingAssistantPreferenceDescription: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.aiWritingAssistant.preferences.description',
    description: 'Description for AI writing assistant preference',
    defaultMessage:
      'Powered by Atlassian Intelligence, use the AI writing assistant to draft pull request descriptions based on code changes being made or brainstorm to help provide comments and code review more efficiently.',
  },
  atlassianIntelligenceAiWritingAssistantPreferenceDescriptionLearnMore: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.aiWritingAssistant.preferences.description.learnMore',
    description: 'Hyperlink message for AI writing assistant description',
    defaultMessage: 'Learn more.',
  },
  atlassianIntelligenceAgenticPipelinesPreferenceHeader: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.agenticPipelines.preferences.header',
    description: 'Header for Agentic Pipelines preference',
    defaultMessage: 'Agentic pipelines',
  },
  atlassianIntelligenceAgenticPipelinesPreferenceDescription: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.agenticPipelines.preferences.description',
    description:
      'Description for Agentic Pipelines preference when a user is registered to Beta',
    defaultMessage:
      'Use AI agents in your Bitbucket pipelines to automate tasks like updating documentation, removing feature flags, and suggesting code improvements.',
  },
  atlassianIntelligenceAgenticPipelinesRegisterButton: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.agenticPipelines.register',
    description:
      'Registration button for Agentic Pipelines when a user is not registered to Beta',
    defaultMessage: 'Register',
  },
  atlassianIntelligenceThingsToKnowHeader: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.thingsToKnow.header',
    description: 'Header for Atlassian Intelligence Things to Know section',
    defaultMessage: 'Things you should know:',
  },
  atlassianIntelligenceThingsToKnowTrustCenter: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.thingsToKnow.trustCenter',
    description:
      'Trust Center description for Atlassian Intelligence Things to Know section',
    defaultMessage:
      "Atlassian Intelligence is governed by our trust standards but hasn't undergone any third-party security or compliance certifications. Read more at the {trustCenterLink}.",
  },
  atlassianIntelligenceThingsToKnowTrustCenterLinkText: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.thingsToKnow.trustCenter.link',
    description:
      'Trust Center link for Atlassian Intelligence Things to Know section',
    defaultMessage: 'Atlassian Trust Center',
  },
  atlassianIntelligenceThingsToKnowAcceptableUse: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.thingsToKnow.acceptableUse',
    description:
      'Acceptable Use description for Atlassian Intelligence Things to Know section',
    defaultMessage:
      'Any AI-generated content or user-written prompts must align with our {acceptableUsePolicyLink}.',
  },
  atlassianIntelligenceThingsToKnowAcceptableUseLinkText: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.thingsToKnow.acceptableUse.link',
    description:
      'Acceptable Use link for Atlassian Intelligence Things to Know section',
    defaultMessage: 'Acceptable Use Policy',
  },
  atlassianIntelligenceThingsToKnowFeaturesVary: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.thingsToKnow.featuresVaryApps',
    description:
      'Features Vary description for Atlassian Intelligence Things to Know section',
    defaultMessage:
      'AI features vary between different apps and plan editions, and some apps may have extra features and settings that administrators can configure.',
  },
  atlassianIntelligenceThingsToKnowAdditionalFeatures: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.thingsToKnow.additionalFeaturesApps',
    description:
      'Additional Features description for Atlassian Intelligence Things to Know section',
    defaultMessage:
      'Some apps may have additional features or settings that admins can configure within the app.',
  },
  atlassianIntelligenceThingsToKnowDeactivate: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.thingsToKnow.deactivateApps',
    description:
      'Deactivate description for Atlassian Intelligence Things to Know section',
    defaultMessage:
      'You can deactivate Atlassian Intelligence for an app at any time.',
  },
  atlassianIntelligenceActivatedFlagTitle: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.activate.flag.title',
    description: 'Title for Atlassian Intelligence activated flag',
    defaultMessage: 'Atlassian Intelligence activated',
  },
  atlassianIntelligenceActivatedFlagDescription: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.activate.flag.description',
    description: 'Description for Atlassian Intelligence activated flag',
    defaultMessage:
      'Your users can now use Atlassian Intelligence in Bitbucket.',
  },
  atlassianIntelligenceActivatedFlagLearnMoreLinkText: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.activate.flag.learnMore',
    description: 'Learn more link for Atlassian Intelligence activated flag',
    defaultMessage: 'Learn more',
  },
  atlassianIntelligenceActivatedFlagActivateForOtherAppsLinkText: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.activate.flag.activateForOtherApps',
    description:
      'Activate for other apps link for Atlassian Intelligence activated flag',
    defaultMessage: 'Activate for other apps',
  },
  atlassianIntelligenceFailedToActivateFlagTitle: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.activate.failed.title',
    description: 'Title for Atlassian Intelligence failed to activate flag',
    defaultMessage: "We're unable to activate Atlassian Intelligence",
  },
  atlassianIntelligenceDeactivatedFlagTitle: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.deactivate.flag.title',
    description: 'Title for Atlassian Intelligence deactivated flag',
    defaultMessage: 'Atlassian Intelligence deactivated',
  },
  atlassianIntelligenceDeactivatedFlagDescription: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.deactivate.flag.description',
    description: 'Description for Atlassian Intelligence deactivated flag',
    defaultMessage:
      "We have deactivated Atlassian Intelligence for {workspaceSlug}. Let your team know it's not available.",
  },
  atlassianIntelligenceFailedToDeactivateFlagTitle: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.deactivate.failed.title',
    description: 'Title for Atlassian Intelligence failed to deactivate flag',
    defaultMessage: "We're unable to deactivate Atlassian Intelligence",
  },
  atlassianIntelligenceDeactivateModalTitle: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.deactivate.modal.title',
    description: 'Title for Atlassian Intelligence deactivate modal',
    defaultMessage: 'Deactivate Atlassian Intelligence',
  },
  atlassianIntelligenceDeactivateModalDescription: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.deactivate.modal.description',
    description: 'Description for Atlassian Intelligence deactivate modal',
    defaultMessage:
      "Your users will no longer be able to use Atlassian Intelligence for Bitbucket. This won't impact any content created with AI.",
  },
  atlassianIntelligenceFailedFlagDescription: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.failed.description',
    description:
      'Description for Atlassian Intelligence failed to deactivate flag',
    defaultMessage: 'Try again, if this keeps happening contact support.',
  },
  atlassianIntelligenceTurnOnRovoChatFlagTitle: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.turnOn.rovoChat.flag.title',
    description: 'Title for Rovo Chat flag toggle ON',
    defaultMessage: 'Rovo Chat has been turned on',
  },
  atlassianIntelligenceTurnOnRovoChatFlagDescription: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.turnOn.rovoChat.flag.description',
    description: 'Description for Rovo Chat flag toggle ON',
    defaultMessage: 'We have turned on Rovo Chat for {workspace}.',
  },
  atlassianIntelligenceTurnOffRovoChatFlagTitle: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.turnOff.rovoChat.flag.title',
    description: 'Title for Rovo Chat flag toggle OFF',
    defaultMessage: 'Rovo Chat has been turned off',
  },
  atlassianIntelligenceTurnOffRovoChatFlagDescription: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.turnOff.rovoChat.flag.description',
    description: 'Description for Rovo Chat flag toggle ON',
    defaultMessage:
      "We have turned off Rovo Chat for {workspace}. Let your team know it's not available.",
  },
  atlassianIntelligenceToggleRovoChatFlagError: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.toggle.rovoChat.flag.error',
    description: 'Title for Rovo Chat flag toggle ERROR',
    defaultMessage: 'Rovo Chat could not be toggled',
  },
  atlassianIntelligenceTurnOnAgenticPipelinesFlagTitle: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.turnOn.agenticPipelines.flag.title',
    description: 'Title for Agentic Pipelines flag toggle ON',
    defaultMessage: 'Agentic Pipelines has been turned on',
  },
  atlassianIntelligenceTurnOnAgenticPipelinesFlagDescription: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.turnOn.agenticPipelines.flag.description',
    description: 'Description for Agentic Pipelines flag toggle ON',
    defaultMessage: 'We have turned on Agentic Pipelines for {workspace}.',
  },
  atlassianIntelligenceTurnOffAgenticPipelinesFlagTitle: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.turnOff.agenticPipelines.flag.title',
    description: 'Title for Agentic Pipelines flag toggle OFF',
    defaultMessage: 'Agentic Pipelines has been turned off',
  },
  atlassianIntelligenceTurnOffAgenticPipelinesFlagDescription: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.turnOff.agenticPipelines.flag.description',
    description: 'Description for Agentic Pipelines flag toggle ON',
    defaultMessage:
      "We have turned off Agentic Pipelines for {workspace}. Let your team know it's not available.",
  },
  atlassianIntelligenceToggleAgenticPipelinesFlagError: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.toggle.agenticPipelines.flag.error',
    description: 'Title for Agentic Pipelines flag toggle ERROR',
    defaultMessage: 'Agentic Pipelines could not be toggled',
  },
  atlassianIntelligenceToggleWritingAssistantFlagError: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.toggle.writingAssistant.flag.error',
    description: 'Title for ai writing assistant flag toggle ERROR',
    defaultMessage: 'AI writing assistant could not be toggled',
  },
  atlassianIntelligenceTurnOnWritingAssistantFlagTitle: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.turnOn.writingAssistant.flag.title',
    description: 'Title for AI writing assistant flag toggle ON',
    defaultMessage: 'AI writing assistant has been turned on',
  },
  atlassianIntelligenceTurnOnWritingAssistantFlagDescription: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.turnOn.writingAssistant.flag.description',
    description: 'Description for writing assistant flag toggle ON',
    defaultMessage: 'We have turned on AI writing assistant for {workspace}.',
  },
  atlassianIntelligenceTurnOffWritingAssistantFlagTitle: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.turnOff.writingAssistant.flag.title',
    description: 'Title for AI writing assistant flag toggle OFF',
    defaultMessage: 'AI writing assistant has been turned off',
  },
  atlassianIntelligenceTurnOffWritingAssistantFlagDescription: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.turnOff.writingAssistant.flag.description',
    description: 'Description for AI writing assistant flag toggle OFF',
    defaultMessage:
      "We have turned off AI writing assistant for {workspace}. Let your team know it's not available.",
  },
  atlassianIntelligenceFailedFlagDescriptionLinkText: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.failed.description.link',
    description:
      'Description link for Atlassian Intelligence failed to deactivate flag',
    defaultMessage: 'Contact Support',
  },
  atlassianIntelligenceValidateAcceptToS: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.validateToS',
    description: 'Validation message for accepting the ToS',
    defaultMessage:
      'You must accept the Atlassian Intelligence specific terms to activate Atlassian Intelligence.',
  },
  atlassianIntelligenceActivateTerms: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.activateTerms',
    description:
      'Agree to terms and conditions for activating Atlassian Intelligence. The "Atlassian Intelligence specific terms" link text is wrapped in <link> tags.',
    defaultMessage:
      'By activating Atlassian Intelligence, I agree to the <link>Atlassian Intelligence specific terms</link>. (required)',
  },
  atlassianIntelligenceUpgradeToPaidTitle: {
    id: 'frontbucket.workspace.settings.atlassianIntelligence.upgradeToPaidTitle',
    description:
      'Title text for prompt to upgrade to Paid for Atlassian Intelligence access',
    defaultMessage: 'Atlassian Intelligence is a paid feature',
  },
});
